<template>
  <div class="templates">
    <div v-for="menu in templates" :key="`template_${menu.menuId}`" class="item">
      <router-link :to="{name: 'menuItem', params: {id: `copy_${menu.menuData.id}`, oId: menu.menuData.id, template: true}}" class="subject">
        <img src="~@/assets/img/ico_template.svg" alt="">
        <p class="title">{{ menu.menuData.name }}</p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Templates',
  props: [
    'templates'
  ]
}
</script>

<style lang="scss" scoped>
.templates {
  position: fixed;
  top: 70px;
  right: 310px;
  bottom: 10px;
  width: 300px;
  overflow: auto;
  padding: 15px;
  border: 1px solid $color-lgrey2;
  border-right: none;
  background-color: $color-white;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  transition: all 0.3s;
}
.item {
  margin-bottom: 15px;
  color: $color-grey;
  border: 1px solid $color-lgrey2;
  border-radius: 2px;
  &:hover {
    color: $color-primary;
    border-color: $color-primary;
    box-shadow: 0 0 5px rgba(0,0,0,0.15);
    img {
      opacity: 0.3;
    }
  }
  .subject {
    display: flex;
    align-items: center;
    padding: 15px 15px 15px 10px;
  }
  img {
    width: 32px;
    opacity: 0.15;
  }
  .title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:2;
    overflow: hidden;
    max-height: 3em;
    margin-left: 0.5em;
  }
}
.editMode .templates {
  top: 38px;
  right: 280px;
  bottom: 0;
}
</style>
